import './index.css';

import * as React from 'react';
import { connect } from 'react-redux';
import Constants from 'src/common/Constants';
import Group from 'src/entities/Group';
import Member from 'src/entities/Member';

import {
  createMemo,
  destroyMemo,
  readMemo,
  readMemosByGroup,
  truncateMemos,
  updateMemo,
  updateMemos
} from '../../actions/memo';
import Memo from '../../entities/Memo';
import Cancel from '../../res/img/cancel_gray.svg';
import Profile from '../../res/img/member.svg';
import OtherActionsIcon from '../../res/img/other_actions.svg';
import PlusWhite from '../../res/img/plus_white.svg';
import Navigation from '../Navigation/global';
import NavigationMember from '../Navigation/member';
import MemoSort from '../Navigation/memoSort';
import SwitchAdmin from '../Navigation/switchAdmin';
import MemoCreate from './create';
import MemoItem from './item';
import OtherActions from './otherActions';

interface IProps {
  account: Member;
  group: Group;
  groups: Group[];
  memos: Memo[];
  allMemos: Memo[];
  members: Member[];
  readMemo: (memo: Memo) => void;
  createMemo: (memo: Memo) => void;
  updateMemo: (memo: Memo) => void;
  updateMemos: (memo: Memo[]) => void;
  destroyMemo: (memo: Memo) => void;
  readMemosByGroup: (group: Group, offset: number, limit: number) => void;
  truncateMemos: () => void;
}

interface IState {
  doesShowPopup: boolean;
  popupMemoId: number;
  newMemo: Memo;
  doesShowNewMemoForm: boolean;
  sortFunc: any;
  filterFunc: any;
  loadedApis: number[];
  isReference: boolean;
  offset: number;
  filterByMember: number;
  countMemos: number;
  isFullyLoaded: boolean;
  isOnly: boolean;
  onlyMemoId: number;
}

class MemoComponent extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      doesShowPopup: false,
      popupMemoId: 0,
      doesShowNewMemoForm: false,
      sortFunc: undefined,
      filterFunc: undefined,
      loadedApis: [],
      newMemo: new Memo(),
      isReference: false,
      offset: 1,
      filterByMember: 0,
      isFullyLoaded: false,
      countMemos: 0,
      isOnly: false,
      onlyMemoId: 0
    };

    this.showNewMemoForm = this.showNewMemoForm.bind(this);
    this.hideNewMemoForm = this.hideNewMemoForm.bind(this);
    this.setSortFunc = this.setSortFunc.bind(this);
    this.showPopup = this.showPopup.bind(this);
    this.hidePopup = this.hidePopup.bind(this);
    this.loadMoreMemos = this.loadMoreMemos.bind(this);
    this.loadAllMemos = this.loadAllMemos.bind(this);
    this.filterByMember = this.filterByMember.bind(this);
  }

  componentWillMount() {
    this.props.truncateMemos();
  }

  componentDidMount() {
    // for reference
    if (location.hash.includes('reference') && !this.state.isReference) {
      const fromId = location.hash.split('=')[1];
      const memo = new Memo();
      memo.memo = fromId + '番関連。';
      this.setState({
        doesShowNewMemoForm: true,
        newMemo: memo,
        isReference: true
      });
      this.showPopup(Number(fromId));
    }

    // popup指定
    if (location.hash.includes('popup')) {
      const memoId = Number(location.hash.split('=')[1]);
      this.showPopup(memoId);
    }

    // only指定
    if (location.hash.includes('only')) {
      const memoId = Number(location.hash.split('=')[1]);
      const memo = new Memo();
      memo.id = memoId;
      this.props.readMemo(memo);
      this.setState({
        isOnly: true,
        onlyMemoId: memoId
      });
    }

    // create
    if (location.hash.includes('create')) {
      this.setState({
        doesShowNewMemoForm: true
      });
    }
  }

  componentDidUpdate() {
    if (
      this.props.group !== undefined &&
      !this.state.loadedApis.includes(this.props.group.id)
    ) {
      this.setState({
        loadedApis: [...this.state.loadedApis, this.props.group.id]
      });
      this.props.readMemosByGroup(this.props.group, 0, 30);
      // this.props.readMemosByGroup(this.props.group, 0, 500);
    }

    if (this.state.countMemos !== this.props.memos.length) {
      this.setState({
        countMemos: this.props.memos.length,
        isFullyLoaded: this.props.memos.length - this.state.countMemos !== 30
      });
    }
  }

  render() {
    if (this.props.group === undefined) {
      return null;
    }

    if (!this.props.group.functions.includes(Constants.FUNCTION_MEMO)) {
      return (
        <div id="MemoIndex">
          {this.renderHeader()}
          <div id="FunctionNotFound">
            メモ機能は本グループで無効になっています。
          </div>
        </div>
      );
    }

    let memos = this.props.memos;

    if (this.state.isOnly) {
      const onlyMemo = this.props.allMemos.find(
        memo => memo.id === this.state.onlyMemoId
      );
      memos = onlyMemo !== undefined ? [onlyMemo] : [];
    } else {
      if (this.state.filterFunc !== undefined) {
        memos = memos.filter(this.state.filterFunc);
      }

      if (this.state.filterByMember !== 0) {
        memos = memos.filter(
          memo =>
            memo.performers.includes(this.state.filterByMember as number) ||
            memo.reporters.includes(this.state.filterByMember as number)
        );
      }

      if (this.state.sortFunc !== undefined) {
        memos = memos.sort(this.state.sortFunc);
      }
    }

    const popupMemo = this.props.allMemos.find(
      memo => memo.id === this.state.popupMemoId
    );

    return (
      <div id="MemoIndex">
        {this.renderHeader(memos)}

        <div id="Memos">
          {(this.props.group.admins.includes(this.props.account.id) ||
            this.props.group.isPublic) &&
          this.state.doesShowNewMemoForm ? (
            <div id="NewMemoForm">
              <MemoCreate
                createMemo={this.props.createMemo}
                hideNewMemoForm={this.hideNewMemoForm}
                members={this.props.members.filter(member =>
                  this.props.group.members.includes(member.id)
                )}
                account={this.props.account}
                group={this.props.group}
                newMemo={this.state.newMemo}
              />
            </div>
          ) : null}

          {memos.length ? (
            <div>
              {memos.map(memo => (
                <MemoItem
                  key={memo.id}
                  memo={memo}
                  group={this.props.group}
                  groups={this.props.groups}
                  members={this.props.members}
                  account={this.props.account}
                  updateMemo={this.props.updateMemo}
                  destroyMemo={this.props.destroyMemo}
                  togglePopup={this.showPopup}
                />
              ))}
            </div>
          ) : (
            <div id="NoMemo">メモがありません</div>
          )}

          {!this.state.isFullyLoaded ? (
            <div id="LoadContainer">
              <button id="LoadMore" onClick={this.loadMoreMemos}>
                さらに読み込む
              </button>
              <button id="LoadAll" onClick={this.loadAllMemos}>
                すべて読み込む
              </button>
            </div>
          ) : (
            <div id="FullyLoaded">すべてのメモを読み込みました</div>
          )}
        </div>

        {(this.props.group.admins.includes(this.props.account.id) ||
          this.props.group.isPublic) &&
        !this.state.doesShowNewMemoForm ? (
          <div
            id="TriggerNewMemo"
            onMouseUp={this.showNewMemoForm}
            onTouchEnd={this.showNewMemoForm}
          >
            <img src={PlusWhite} />
          </div>
        ) : null}

        {this.state.doesShowPopup && popupMemo !== undefined ? (
          <div id="PopupMemo">
            <div className="Delete" onClick={this.hidePopup}>
              <img src={Cancel} />
            </div>
            <div id="PopupMemoItem">
              <MemoItem
                memo={popupMemo}
                group={this.props.group}
                groups={this.props.groups}
                members={this.props.members}
                account={this.props.account}
                updateMemo={this.props.updateMemo}
                destroyMemo={this.props.destroyMemo}
                togglePopup={this.showPopup}
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  renderHeader(memos?: Memo[]) {
    return (
      <div>
        <Navigation group={this.props.group.title} />

        <div id="NavigationFunction">
          <NavigationMember function="memo" group={this.props.group} />

          <div id="NavigationFunctionRight">
            <MemoSort
              setSortFunc={this.setSortFunc}
              account={this.props.account}
            />

            {this.props.group.admins.includes(this.props.account.id) ? (
              <div id="FilterByMember">
                <img src={Profile} />

                <select onChange={this.filterByMember} defaultValue="0">
                  <option value={0}>全員</option>
                  {this.props.members
                    .filter(
                      member =>
                        this.props.group.members.includes(member.id) &&
                        !member.archived
                    )
                    .map(member => (
                      <option value={member.id}>
                        {member.nameLast}
                        {member.nameFirst}
                      </option>
                    ))}
                </select>
              </div>
            ) : null}

            {memos !== undefined ? (
              <OtherActions
                account={this.props.account}
                memos={memos}
                members={this.props.members}
                updateMemos={this.props.updateMemos}
              />
            ) : null}

            {this.props.account.isSystemAdmin ||
            this.props.group.admins.includes(this.props.account.id) ? (
              <div id="SwitchAdminContainer">
                <SwitchAdmin group={this.props.group} />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  showNewMemoForm() {
    this.setState({
      doesShowNewMemoForm: true
    });
  }

  hideNewMemoForm() {
    this.setState({
      doesShowNewMemoForm: false
    });
  }

  setSortFunc(sortFunc: any, filterFunc: any) {
    this.setState({
      sortFunc,
      filterFunc
    });
  }

  showPopup(memoId: number) {
    const memo = new Memo();
    memo.id = memoId;
    this.props.readMemo(memo);
    this.setState({
      doesShowPopup: true,
      popupMemoId: memoId
    });
  }

  hidePopup(e: any) {
    this.setState({
      doesShowPopup: false,
      popupMemoId: 0
    });
  }

  loadMoreMemos(e: any) {
    this.props.readMemosByGroup(this.props.group, this.state.offset, 30);
    this.setState({
      offset: this.state.offset + 1
    });
  }

  loadAllMemos(e: any) {
    this.props.readMemosByGroup(this.props.group, 0, 1000);
    this.setState({
      offset: this.state.offset + 1
    });
  }

  filterByMember(e: any) {
    this.setState({
      filterByMember: Number(e.target.value)
    });
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  account: state.Account,
  groups: state.Group,
  group: state.Group.find(
    (group: Group) => group.title === ownProps.match.params.group
  ),
  members: state.Member,
  memos:
    state.Group.length > 0 && state.Memo.length > 0
      ? state.Memo.filter(
          (memo: Memo) =>
            memo.groupId ===
            state.Group.find(
              (group: Group) => group.title === ownProps.match.params.group
            ).id
        )
      : [],
  allMemos: state.Memo
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    readMemo(memo: Memo) {
      dispatch(readMemo(memo));
    },
    createMemo(memo: Memo) {
      dispatch(createMemo(memo));
    },
    updateMemo(memo: Memo) {
      dispatch(updateMemo(memo));
    },
    updateMemos(memos: Memo[]) {
      dispatch(updateMemos(memos));
    },
    readMemosByGroup(group: Group, offset: number, limit: number) {
      dispatch(readMemosByGroup(group, offset, limit));
    },
    destroyMemo(memo: Memo) {
      dispatch(destroyMemo(memo));
    },
    truncateMemos() {
      dispatch(truncateMemos());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MemoComponent);



// WEBPACK FOOTER //
// ./src/components/Memo/group.tsx